export default {
  title: 'Tax details',
  buttons: {
    save: 'Save',
  },
  toasts: {
    success: 'Successfully saved your information.',
  },
};
